import cache from './cache.js';
import getUserAgent from './getUserAgent.js';
import regex from './isWebOs.json';

export default cache('isWebOs', function isWebOs() {
  const pattern = new RegExp(...regex);
  return pattern.test(getUserAgent());
});